export const ErrorThrower = ({ error }) => {
  throw error;
};
